import type { RcmSettingsGroup, RcmSettingsPageDef, RcmSettingsPageId } from './types';

export const RCM_SETTINGS_PAGES: RcmSettingsPageDef[] = [
  // AI Configuration group
  {
    id: "ai_dispatch_policies",
    group: "AI Configuration",
    label: "AI Dispatch Policies",
    built: true,
    default: true,
  },
  {
    id: "alert_thresholds",
    group: "AI Configuration",
    label: "Alert Thresholds",
    built: true,
  },
  {
    id: "dispatch_windows",
    group: "AI Configuration",
    label: "Dispatch Windows",
    built: true,
  },
  {
    id: "ai_performance_config",
    group: "AI Configuration",
    label: "AI Performance Configuration",
    built: true,
  },
  // Document Center group
  {
    id: "document_center_config",
    group: "Document Center",
    label: "Configuration",
    built: true,
  },
  // Reference group
  {
    id: "ar_rules",
    group: "Reference",
    label: "AR Rules · Read-only",
    built: true,
  },
];

export const RCM_PAGES_BY_GROUP = RCM_SETTINGS_PAGES.reduce<
  Partial<Record<RcmSettingsGroup, RcmSettingsPageDef[]>>
>((acc, p) => {
  const group = acc[p.group] ?? [];
  group.push(p);
  acc[p.group] = group;
  return acc;
}, {});

export const RCM_SETTINGS_GROUP_ORDER: RcmSettingsGroup[] = ["AI Configuration", "Document Center", "Reference"];

// v10: icon keys map to icon components in the renderer (see GroupIcon())
export const RCM_SETTINGS_GROUP_ICONS: Record<RcmSettingsGroup, string> = {
  "AI Configuration": "settings",
  "Document Center": "doc",
  Reference: "list",
};

export const RCM_SETTINGS_PAGE_META: Record<RcmSettingsPageId, { title: string; subtitle: string }> = {
  ai_dispatch_policies: {
    title: "AI Dispatch Policies",
    subtitle:
      "For each Worklist category, control whether AI handles it automatically and at what risk tier. Defaults ship conservative; tune based on practice comfort.",
  },
  alert_thresholds: {
    title: "Alert Thresholds",
    subtitle:
      "Numeric thresholds that determine when items become Worklist-worthy. Operators can also reach this page from the AR · 'Configure AR rules' link.",
  },
  dispatch_windows: {
    title: "Dispatch Windows",
    subtitle:
      "When AI is allowed to text and call. AI batches non-urgent work outside the window for dispatch during it.",
  },
  document_center_config: {
    title: "Document Center Configuration",
    subtitle:
      "Capture surfaces, classification confidence thresholds, retention, and cross-references. Most practices leave defaults intact.",
  },
  ar_rules: {
    title: "AR Rules · Read-only",
    subtitle:
      "AR-related patient outreach configured in Recall. This page shows the current rules and deep-links to Recall for changes.",
  },
  ai_performance_config: {
    title: "AI Performance Configuration",
    subtitle:
      "Tune the formulas that produce AI Performance numbers. Defaults are conservative and work for ~90% of practices; this surface exists for the practices that want to refine.",
  },
};
